import { NavItem } from '../../../../Common/Layout/components/Navbar/navbar.component';

import { mediaRelationsNavItem } from '../media-relations-nav-item';
import { mediaIntelligenceNavItem } from '../media-intelligence-nav-item';
import { socialNavItem } from '../social-nav-item.config';

export const resellerLeftNav: NavItem[] = [
    mediaRelationsNavItem,
    mediaIntelligenceNavItem,
    socialNavItem
];
